<template>
  <div>
    <f7-list media-list>
      <f7-list-item
      v-for="accountItem in filteredAccounts"
      :key="accountItem.id"
      v-bind:media="'<div class=\'manualChip\'>'+accountItem.name[0].toUpperCase()+'</div>'"
      v-bind:title="accountItem.name"
      @click="switchAccount(accountItem.id)">
        <f7-swipeout-actions>
          <f7-swipeout-button
            data-confirm="You will not be part of this account anymore"
            data-confirm-title="Disengage?"
            data-close-on-cancel="true"
            delete>
            Delete
          </f7-swipeout-button>
        </f7-swipeout-actions>
      </f7-list-item>
    </f7-list>
</div>
</template>
<script>
import {loadPage} from '@/helpers/routing'
// import {del} from '@/helpers/api'
export default {
  name: 'AccountsList',
  props: ['accounts', 'filterBy'],
  computed: {
    filteredAccounts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var k in that.accounts) {
          if (that.accounts[k].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.accounts[k])
          }
        }
        return result
      }

      return this.accounts
    }
  },
  created () {
  },
  methods: {
    switchAccount (id) {
      this.$engine.accounts.switchTo(id)
      this.$bus.emit('refresh-cache-menu')
      let url = ''
      switch (this.$engine.user.currentService.name) {
        case 'Direct Debit': url = '/directDebit/inbox/'; break
        case 'Direct Payments': url = '/directPayments/inbox/'; break
        default: url = '/inbox/0'; break
      }
      loadPage(this, {url: url})
    }
  }
}
</script>

<style>
.list-block {
  padding: 0px 0px 0px 0px;
  margin: 0px 0px 0px 0px;
}
</style>
